import { Grid, Hidden, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Outlet, useParams } from "react-router-dom";
import { IUserProfileManage } from "../../_common/interface/users/iUserProfileManage";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { stringToDateFormat } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { userInformationService } from "../../_services/userInformation.service";
import { UserProfileProfileImageManage } from "../userProfile/userProfile-profileImageManage";
import { UserAddressManage } from "./user-addressManage";
import { UserInfoView } from "./user-infoView";
import { UserMediaManage } from "./user-mediaManage";
import { UserProfilePagePersonalInfo } from "./user-profilePagePersonalInfo";
import { UserTrainingManage } from "./user-trainingManage";
import { UserAddressView } from "./user-addressView";
import { UserMediaView } from "./user-mediaView";
import { UserTrainingView } from "./user-trainingView";
import { UserProfilePagePersonalInfoView } from "./user-profilePagePersonalInfoView";

export function UserView() {

    const { userId } = useParams<{ userId: string }>();

    const resetData = () => ({
        id: "",
        firstName: '',
        lastName: '',
        name: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        county: '',
        postalCode: '',
        username: '',
        genderId: null,
        dateOfBirth: null,
        nationality: null,
        fines: []
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState<IUserProfileManage>(resetData);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .get(id)
            .then(
                (json) => {
                    setData(_data => {
                        json.role = json.roles;
                        return {
                            ...json,
                            dateOfBirth: stringToDateFormat(json.dateOfBirth),
                            brdsLicenseExpirationDate: stringToDateFormat(json.brdsLicenseExpirationDate),
                            competitionInsuranceExpirationDate: stringToDateFormat(json.competitionInsuranceExpirationDate),
                            mediaLicenseExpirationDate: stringToDateFormat(json.mediaLicenseExpirationDate),
                            officialLicenseExpirationDate: stringToDateFormat(json.officialLicenseExpirationDate),
                            competitionLicenseExpirationDate: stringToDateFormat(json.competitionLicenseExpirationDate),
                        }
                    });
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit() {
        setIsLoading(true);
        setIsSaving(true);
        return userInformationService
            .updateInsuranceInformation({ ...data, userId: userId })
            .then(
                (json) => {
                    toastr.success("Insurance information saved successfully");
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
                setIsSaving(false)
            });
    }

    function handleChange(event: any) {
        setData((__data) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function handleDateChange(event: any) {
        setData((__data) => {
            return { ...__data, [event.target.name]: stringToDateFormat(event.target.value) }
        });
    };

    return (

        <Grid container style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <Hidden mdUp>
                <UserProfilePagePersonalInfoView />
            </Hidden>

            {(!accountService.isOrganiser) &&
                <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                    <Paper>
                        <UserInfoView />
                    </Paper>
                </Grid>
            }

            {(!accountService.isOrganiser) &&
                <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                    <Paper>
                        <UserAddressView />
                    </Paper>
                </Grid>
            }
            <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "8px" }}>

                <Paper>
                    <ValidatorForm
                        onSubmit={() => { }}
                        noValidate>
                        <Grid container spacing={2} sx={{ mt: 0 }}>

                            <Grid item xs={12}>
                                <Typography variant="h6" textAlign="center">Insurance Information</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidatorHcs
                                    key="insuranceLicenseNumber"
                                    name="insuranceLicenseNumber"
                                    label="Insurance Number"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.insuranceLicenseNumber}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidatorHcs
                                    type="date"
                                    key="competitionInsuranceExpirationDate"
                                    name="competitionInsuranceExpirationDate"
                                    label="IRDS Insurance Expiration Date"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.competitionInsuranceExpirationDate}
                                    onChange={handleDateChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <TextValidatorHcs
                                    key="brdsLicenseNumberPrefix"
                                    name="brdsLicenseNumberPrefix"
                                    label="BRDS Prefix"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.brdsLicenseNumberPrefix}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <TextValidatorHcs
                                    key="brdsLicenseNumber"
                                    name="brdsLicenseNumber"
                                    label="BRDS Insurance Number"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.brdsLicenseNumber}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextValidatorHcs
                                    type="date"
                                    key="brdsLicenseExpirationDate"
                                    name="brdsLicenseExpirationDate"
                                    label="BRDS Insurance Expiration Date"
                                    fullWidth
                                    disabled={!accountService.isAdmin}
                                    value={data.brdsLicenseExpirationDate}
                                    onChange={handleDateChange}
                                />
                            </Grid>
                        </Grid>
                    </ValidatorForm >

                </Paper>
            </Grid>

            <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <UserMediaView />
            </Grid>

            <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <UserTrainingView />
            </Grid>

            <Outlet></Outlet>
        </Grid >

    );

}
